module.exports = __webpack_public_path__ + "img/main.md.67c925c6.jpg";